/* Preview stub — generated for the KCC branding live-preview lift of Studies + TopNavbar.
   No backend in this app; these inert modules satisfy the lifted components' imports. */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
 "isProfileContextModalVisible": false
};

const sliceObj = createSlice({
	name: "profileContext",
	initialState,
	reducers: {
		setIsProfileContextModalVisible: (_state, _action: PayloadAction<any>) => {},
	},
});

export const { setIsProfileContextModalVisible } = sliceObj.actions;
export default sliceObj.reducer;
